module.exports = __webpack_public_path__ + "img/youjiantou-2.6e48d44b.svg";